<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="close"
  >
    <div
      class="relative w-full lg:w-[83%] max-h-screen bg-[#f8f8f8] p-[40px] overflow-auto"
    >
      <button
        class="absolute right-12 top-12 cursor-pointer z-10"
        type="button"
        @click="close"
      >
        <span class="mdi text-xl mdi-close"></span>
      </button>
      <div
        class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]"
      >
        <h2 class="text-[##353535] text-[20px] leading-[28px] font-semibold">
          Viewing sales Report: Stock Issued Sales
        </h2>
        <div
          class="flex xs:flex-col md:flex-row xs:justify-start md:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 md:items-center"
        >
          <p class="text-[#353535] text-[14px] leading-[20px] font-medium">
            Stock issued sales report
            <span
              v-if="
                this.filter.dateStart == '' || this.filter.dateStart == null
              "
            >
              <span> <strong>as at</strong> {{ this.filter.dateEnd }}</span>
            </span>
            <span
              v-if="
                this.filter.dateStart != '' &&
                  this.filter.dateStart != null &&
                  this.filter.dateEnd != '' &&
                  this.filter.dateEnd != null
              "
            >
              <span
                v-if="
                  this.filter.dateStart != '' && this.filter.dateStart != null
                "
                ><span
                  ><strong>from</strong> {{ this.filter.dateStart }}
                </span></span
              >
              <span> <strong>to</strong> {{ this.filter.dateEnd }}</span>
            </span>
          </p>
          <div
            class="flex gap-1 sm:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
          >
            <button
              @click="viewFilter"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
            >
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
            <!-- <button
              @click="csvExport(csvDataAll)"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
            >
              <span class="">
                <img src="/assets/icon/export.svg" alt="" />
              </span>
              Export Data
            </button> -->
          </div>
        </div>
        <div class="table-responsive">
          <table
            class="table m-0 p-0 dataTable text-nowrap dataex-html5-selectors"
          >
            <thead>
              <tr>
                <th>Sales Agent Name</th>
                <th>Sales Agent Phone</th>
                <th>Product Sold</th>
                <th>Product Code</th>
                <th>Quantity</th>
                <th>Record Date</th>
                <th>Record Time</th>
                <th>Channels</th>
                <th>Longitute</th>
                <th>Latitude</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in ReportItems" :key="item.rowNum">
                <td>{{ item.salesAgentName }}</td>
                <td>{{ item.salesAgentPhoneNumber }}</td>
                <td>{{ item.productSold }}</td>
                <td>{{ item.productCode }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ formatDate(item.recordDate) }}</td>
                <td>{{ formatTime(item.recordTime) }}</td>
                <td>{{ item.channel }}</td>
                <td>{{ item.longitude }}</td>
                <td>{{ item.latitude }}</td>
              </tr>
              <tr v-if="!ReportItems.length">
                <td colspan="12">
                  <div class="text-center">No matching records</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- filter modal -->
    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-filter"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <h4 class="modal-title"><b>Filter</b></h4>
            </div>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label class="col-12 col-sm-4">Start Date: </label>
              <div class="col-12 col-sm-8 ">
                <input
                  :class="['form-control']"
                  type="date"
                  placeholder="Select a date"
                  v-model="filter.dateStart"
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-sm-4">End Date: </label>
              <div class="col-12 col-sm-8 ">
                <input
                  :class="['form-control']"
                  type="date"
                  placeholder="Select a date"
                  v-model="filter.dateEnd"
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-sm-4">Product Name: </label>
              <div class="col-12 col-sm-8 ">
                <input
                  :class="['form-control']"
                  type="text"
                  v-model="filter.productName"
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-12 col-sm-4">Sales Agent Name: </label>
              <div class="col-12 col-sm-8 ">
                <input
                  :class="['form-control']"
                  type="text"
                  v-model="filter.salesAgentName"
                />
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              style="width: 100px;"
              class="btn btn-text btn-space"
              type="button"
              data-dismiss="modal"
              @click="reset"
            >
              <span class="text-danger"> Reset </span>
            </button>

            <button
              style="width: 100px;"
              class="btn btn-primary"
              type="button"
              data-dismiss="modal"
              :disabled="isBusy"
              @click="getStockIssuedSalesReport"
            >
              <span v-if="!isBusy">Filter</span>
              <span v-else>Busy...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import ReportFilterModal from "@/components/Common/ReportFilterModal";
import { exportExcel } from "@/excel";

export default {
  props: ["close"],
  name: "StockIssuedSalesReport",
  components: {
    Select2,
    ReportFilterModal,
  },
  created() {
    this.getStockIssuedSalesReport();
    // this.getSalesMarginExportItemsAll();
  },
  data() {
    return {
      filter: {
        qry: "",
        dateStart: moment()
          .subtract(1, "years")
          .format("YYYY-MM-DD"),
        dateEnd: moment().format("YYYY-MM-DD"),
        productName: "",
        salesAgentName: "",
      },
      isBusy: false,
      isBusyModal: false,
      ReportItems: [],
      ExportReportItemsAll: [],
      count: 0,
      page: 0,
      pageSize: 10,
      pageSizeExport: 999999999,
      hasNext: false,
      hasPrev: false,
      maxPage: 0,
      pageArray: [],
      options: {
        format: "YYYY-MM-DD",
        icons: {
          time: "mdi mdi-time",
          date: "mdi mdi-calendar",
          up: "mdi mdi-chevron-up",
          down: "mdi mdi-chevron-down",
          previous: "mdi mdi-chevron-left",
          next: "mdi mdi-chevron-right",
          today: "mdi mdi-screenshot",
          clear: "mdi mdi-trash",
          close: "mdi mdi-remove",
        },
      },
      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Select Hour", // tip of select hour
        minuteTip: "Select Minute", // tip of select minute
        secondTip: "Select Second", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ), // months of head
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), // months of panel
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks
        cancelTip: "cancel",
        submitTip: "confirm",
      },
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    // csvData() {
    //     return this.exportItems.map(item => ({
    //         ...item
    //     }));
    // },
    // exportItems() {
    //     return this.ReportItems.map(function(item) {
    //         return {
    //             "Product Code": item.productCode,
    //             "Product Name": item.productName,
    //             "Product Unit": item.productUnit,
    //             "Selling Price": item.sellingPrice,
    //             "Opening Stock": item.openingStock,
    //             "Purchases": item.purchases,
    //             "Sales Quantity": item.salesQuantity,
    //             "Closing Stock": item.closingStock,
    //             "Revenue (NGN)": item.revenue,
    //             "Estimated Cost of Goods (NGN)": item.estimatedCostofGoods,
    //             "Estimated Sales Margin": item.estimatedSalesMargin
    //         }
    //     });
    // },
    // csvDataAll() {
    //     return this.exportItemsAll.map(item => ({
    //         ...item
    //     }));
    // },
    // exportItemsAll() {
    //     this.getSalesMarginExportItemsAll();
    //     return this.ExportReportItemsAll.map(function (item) {
    //         return {
    //             "Product Code": item.productCode,
    //             "Product Name": item.productName,
    //             "Product Unit": item.productUnit,
    //             "Selling Price": item.sellingPrice,
    //             "Opening Stock": item.openingStock,
    //             "Purchases": item.purchases,
    //             "Sales Quantity": item.salesQuantity,
    //             "Closing Stock": item.closingStock,
    //             "Revenue (NGN)": item.revenue,
    //             "Estimated Cost of Goods (NGN)": item.estimatedCostofGoods,
    //             "Estimated Sales Margin": item.estimatedSalesMargin
    //         }
    //     });
    // }
  },
  methods: {
    reset() {
      this.filter = {
        qry: "",
        dateStart: moment()
          .subtract(1, "years")
          .format("YYYY-MM-DD"),
        dateEnd: moment().format("YYYY-MM-DD"),
        productName: "",
        salesAgentName: "",
      };
      this.getStockIssuedSalesReport();
    },
    viewExport() {},
    viewFilter() {
      $("#mod-filter").modal("show");
    },
    getStockIssuedSalesReport() {
      this.isBusy = true;

      this.$http
        .get(
          "/Reports/getStockIssueSalesReport?distributorId=" +
            (this.user.parentId ? this.user.parentId : "") +
            (this.filter.salesAgentName
              ? "&salesAgentName=" + this.filter.salesAgentName
              : "") +
            (this.filter.productName
              ? "&productName=" + this.filter.productName
              : "") +
            (this.filter.startDate != ""
              ? "&startDate=" +
                moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
              : "") +
            (this.filter.endDate != ""
              ? "&endDate=" +
                moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
              : "")
        )
        .then(function(res) {
          this.ReportItems = res.body;

          // The following is for pagination
          this.page = res.body.page;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.maxPage = Math.ceil(this.count / this.pageSize);
          this.pageArray = [...Array(this.maxPage).keys()];

          $("#mod-filter").modal("hide");
          this.isBusy = false;
        })
        .catch(function() {
          $("#mod-filter").modal("hide");
          this.isBusy = false;
        });
    },
    // getSalesMarginExportItemsAll() {
    //     this.isBusy = true;

    //     this.$http
    //         .get(
    //             "/Reports/getSalesMarginsReport?page=" +
    //             this.page +
    //             "&pageSize=" +
    //             this.pageSizeExport +
    //             (this.filter.qry != ""
    //                 ? "&query=" + this.filter.qry
    //                 : "") +
    //             (this.filter.dateStart != ""
    //                 ? "&startDate=" +
    //                 moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
    //                 : "") +
    //             (this.filter.dateEnd != ""
    //                 ? "&endDate=" +
    //                 moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
    //                 : "") +
    //             (this.user.parentId ? "&parentId=" + this.user.parentId : "")
    //         )
    //         .then(function (res) {
    //             this.ExportReportItemsAll = res.body.data;

    //             $("#mod-filter").modal("hide");
    //             this.isBusy = false;
    //         })
    //         .catch(function () {
    //             $("#mod-filter").modal("hide");
    //             this.isBusy = false;
    //         });
    // },
    formatDate(date) {
      return moment(date).format("MMMM DD YYYY");
    },
    formatTime(time) {
      let hrChk = parseInt(time.substring(0, 2));
      let newTime = time.substring(0, 5);
      newTime = newTime + (hrChk >= 12 ? " PM" : " AM");
      return newTime;
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    formatNumber(val) {
      return helper.formatNumber(val);
    },
    prev() {
      this.page -= 1;
      this.getStockIssuedSalesReport();
    },
    next() {
      this.page += 1;
      this.getStockIssuedSalesReport();
    },
    // csvExport(arrData) {
    //     let csvContent = "data:text/csv;charset=utf-8,";
    //     csvContent += [
    //         Object.keys(arrData[0]).join(","),
    //         ...arrData.map(item => Object.values(item).join(","))
    //     ]
    //         .join("\n")
    //         .replace(/(^\[)|(\]$)/gm, "");

    //     const data = encodeURI(csvContent);
    //     const link = document.createElement("a");
    //     link.setAttribute("href", data);
    //     link.setAttribute("download", "sales_mergin_report.csv");
    //     link.click();
    // },
    //  excelData(exportData) {
    //     const exportAble = exportData;
    //     const options = {
    //         headers: Object.keys(exportAble[0])
    //     };

    //     const numericHeaders = [
    //         "Selling Price",
    //         "Revenue (NGN)",
    //         "Estimated Cost of Goods (NGN)",
    //         "Estimated Sales Margin",
    //     ];
    //     var titleName = "Sales Margins Report_";
    //     var titleFullname =
    //         this.filter.dateStart === "" || this.filter.dateStart == null
    //         ? titleName + "As At_" + this.filter.dateEnd
    //         : titleName + this.filter.dateStart + "_to_" + this.filter.dateEnd;
    //     const excelData = {
    //         title: titleFullname,
    //         headers: options.headers,
    //         data: exportAble,
    //     };
    //     const businessName = this.$store.getters.getCurrentUser.parent.name;
    //     const businessAddress = this.$store.getters.getCurrentUser.parent.address;
    //     exportExcel(excelData, businessName, businessAddress, numericHeaders);
    // },
  },
};
</script>
